export const PresentationVideoLanguageMap: { [key: string]: string } = {
  it: 'https://www.youtube.com/embed/62GmRGrAtIo?autoplay=1',
  en: 'https://www.youtube.com/embed/_61yxuEyzZ4??autoplay=1',
};
